// extracted by mini-css-extract-plugin
export default {"audioRecordContainer":"_1SdAR","instruction":"_1ijkH","fileUploadContainer":"_1Qi3b"};